import { faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLanguage } from "../../contexts/LanguageContext";

const NotPhotos = () => {
  const { t } = useLanguage();
  return (
    <div
      className="no-photos"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#333",
        paddingTop: "20%",
      }}
    >
      <div className="no-photos-dashboard">
        <FontAwesomeIcon icon={faImage} size="4x" />
        <h1 style={{ padding: "20px 0 0 0", fontSize: "24px" }}>
          {t("notPhotosError.title")}
        </h1>
      </div>
    </div>
  );
};

export default NotPhotos;
